/* cvn-rail-marquee.js — lifted verbatim out of snippets/cvn-rail-marquee.liquid on 2026-09-25 (theme audit v77).
   It used to be an inline <script> re-sent with every page; as an asset it is minified by the CDN and cached.
   Execution point is unchanged: the snippet loads it (blocking, no defer) exactly where the block was. */
  (function () {
    if (window.cvnRailMqInit) return;
    window.cvnRailMqInit = true;

    var MQ = '(max-width: 989.98px)';
    /* AUTO-SCROLL IS OFF (Zeus). The strip is a plain swipeable scroller: the
       shopper moves it, nothing moves on its own. The whole drive below is kept
       and gated on this one flag rather than deleted, because the parts that
       were expensive to get right — owning the position as a float and writing
       an absolute Math.round (the read-modify-write that parks a strip on
       WebKit), the px/s floor, the press-and-hold with its release on window —
       are the parts that would have to be rediscovered to turn it back on.
       Flip to true and it runs again; nothing else needs touching.
       With it off the loop CLONES are skipped too: they exist only so the wrap
       lands on identical pixels, and a strip nobody advances never wraps. */
    var AUTOPLAY = false;
    // px/s, never "seconds per loop" — one duration is a different speed at
    // every viewport, and under ~30px/s a strip reads as stationary
    var SPEED = 42;
    // enough head cards repeated past the end to cover a phone viewport, so the
    // wrap lands on identical pixels instead of a visible jump
    var CLONES = 4;
    var RESUME_MS = 700;

    var mqPhone = null, mqHover = null, mqReduce = null;
    try {
      mqPhone = window.matchMedia(MQ);
      mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    } catch (e) {}
    function isPhone() { return mqPhone ? mqPhone.matches : false; }
    function canHover() { return mqHover ? mqHover.matches : false; }
    function reduced() { return mqReduce ? mqReduce.matches : false; }

    var st = null; // { rail, scroll, pos, setW, raf, hold, holdUntil }

    function stop() {
      if (st && st.raf) { cancelAnimationFrame(st.raf); st.raf = null; }
    }

    /* Put the card's own name in the stack and let CSS order the rest. */
    function prep(scroll) {
      scroll.querySelectorAll('.card-wrapper').forEach(function (cw) {
        var h = cw.querySelector('.card__heading');
        var content = cw.querySelector('.card__content');
        if (!h || !content || h.__cvnMq) return;
        h.__cvnMq = 1;
        /* ⚠ A PAGE CARD ALREADY HAS ITS NAME, IN THE RIGHT PLACE. cvn-rail-cards
           renders it visibly for page context, as a direct child of
           .card__content before .card__information. Moving it to the END here
           is invisible on a phone (the marquee orders with `order:`) and wrong
           at desktop, where no `order` applies and the name would land under
           the price. Leave a served name where it was served. */
        if (h.classList.contains('cvn-rail-name')) return;
        h.classList.remove('visually-hidden');
        h.classList.add('cvn-rail-name');
        // position is irrelevant — `order` decides; appending keeps it out of
        // the way of the chip row cvn-card-colors inserts at firstChild
        content.appendChild(h);
      });
    }

    /* ⚠ THERE ARE TWO RAILS ON /cart, AND EVERYTHING BELOW WAS WRITTEN FOR ONE.
       The drawer is rendered in the LAYOUT, so it is present on every page —
       the cart page included — and it comes FIRST in document order. So
       `document.querySelector('[data-cvn-rail]')` resolves to the DRAWER's
       rail even while the shopper is looking at the page's, and the page's
       rail was therefore never prepared at ANY width.

       The symptom is quiet and expensive: `prep()` is what removes Dawn's
       `visually-hidden` from the card's own <h3>, so without it every card in
       "Picked for you" on /cart renders as a photo, a chip row, a price and a
       Quick view link with NO PRODUCT NAME. Nothing errors, the strip scrolls,
       the cards are clickable — a recommendation nobody can identify.

       Two things follow, and they are separate:
        · the PAGE rail is a marquee at EVERY width, by definition — it is not
          a side panel that collapses on a phone, it is page furniture — so it
          is prepared outside the `isPhone()` gate entirely;
        · `teardown()` must never reach it. Teardown exists to hand the DESKTOP
          side panel back its own layout after a window is narrowed and widened
          again, and it re-hides names and strips `cvn-rail--mq`. Run against
          the page rail it would blank every name the moment someone resized. */
    function pageRails() {
      return Array.prototype.slice.call(
        document.querySelectorAll('[data-cvn-rail][data-cvn-rail-context="page"]')
      );
    }

    function prepPageRails() {
      pageRails().forEach(function (rail) {
        var scroll = rail.querySelector('[data-cvn-rail-scroll]');
        if (!scroll) return;
        /* ⚠ THE CLASS IS NOT TOUCHED HERE, AND THAT IS THE FIX. A page rail
           carries `cvn-rail--mq` from Liquid and keeps it at every width; its
           two forms are decided by media query alone (see the desktop block
           above). This used to toggle the class on the media-query change
           event — which fires AFTER the CSS has already reflowed, so crossing
           990px showed the wrong form for a frame or two and read as a
           stutter rather than a layout change. Nothing about a layout that
           depends only on width belongs in JavaScript.
           What is left here is the work CSS cannot do: adopting the card's
           name (a no-op for page cards, which are served with theirs) and
           binding mouse-drag on a scroller whose scrollbar is hidden. */
        prep(scroll);
        // safe at any width: every handler bindOnce attaches is guarded on
        // `st.scroll === scroll`, so they stay inert unless this rail is the
        // driven one. What it buys is mouse-drag on a hidden-scrollbar strip.
        bindOnce(scroll);
      });
    }
    // the cart page's bridge re-renders a page rail after this file's own
    // observers have already run (its fetch lands last); exposing the prep
    // lets it re-prepare the fresh strip the moment it swaps it in
    window.cvnPrepPageRails = prepPageRails;

    /* ⚠ Clone BEFORE the cards are built. cloneNode does not copy the __cvn
       expando cvn-card-colors uses as its "already built" guard, so a clone of
       a BUILT card would be built a second time and get two chip rows. While
       the rail is still display:none nothing is built (run() skips a card with
       no offsetParent), which is exactly the window this uses. */
    function cloneHead(scroll) {
      if (!AUTOPLAY) return;
      if (scroll.__cvnMqCloned) return;
      var cards = Array.prototype.slice.call(scroll.querySelectorAll('.card-wrapper'));
      if (cards.length < 2) return;
      scroll.__cvnMqCloned = 1;
      // A card built on DESKTOP and then met here (the browser window was
      // narrowed past 990px) already carries its chip row and photo track, and
      // cloneNode would copy those while dropping the __cvn guard that says so
      // — the clone would be built a second time on top of itself. Rather than
      // unpick a built card, skip the loop entirely: the strip stays swipeable
      // and simply does not auto-scroll. A phone never takes this path.
      for (var g = 0; g < cards.length; g++) {
        if (cards[g].__cvn) return;
      }
      var n = Math.min(CLONES, cards.length);
      for (var i = 0; i < n; i++) {
        var c = cards[i].cloneNode(true);
        c.setAttribute('data-cvn-mq-clone', '1');
        scroll.appendChild(c);
      }
      scroll.__cvnMqSet = cards.length;
    }

    /* cvn-card-colors watches body for childList mutations only, so making the
       rail visible (an attribute change) does not wake it — the same poke
       railBoot uses. */
    function poke() {
      var c = document.createComment('cvn-mq-poke');
      document.body.appendChild(c);
      c.remove();
    }

    function measure() {
      if (!st) return;
      var first = st.scroll.querySelector('.card-wrapper');
      var firstClone = st.scroll.querySelector('.card-wrapper[data-cvn-mq-clone]');
      st.setW = (first && firstClone) ? (firstClone.offsetLeft - first.offsetLeft) : 0;
    }

    function frame(t) {
      if (!st) return;
      st.raf = requestAnimationFrame(frame);
      var dt = st.last ? Math.min(0.05, (t - st.last) / 1000) : 0;
      st.last = t;
      var held = st.hold || (st.holdUntil && t < st.holdUntil);
      if (held || !st.setW || reduced()) {
        // the shopper owns the position while they are touching it, and for a
        // moment afterwards so momentum is not fought
        st.pos = st.scroll.scrollLeft;
        return;
      }
      // re-adopt only when something else legitimately moved it; a sub-pixel
      // difference is just the engine quantising our own write
      var actual = st.scroll.scrollLeft;
      if (Math.abs(actual - Math.round(st.pos)) > 2) st.pos = actual;
      st.pos += SPEED * dt;
      if (st.pos >= st.setW) st.pos -= st.setW;
      // ABSOLUTE write from a float we own — never `scrollLeft += step`
      st.scroll.scrollLeft = Math.round(st.pos);
    }

    function drawerOpen() {
      var d = document.querySelector('cart-drawer');
      return !d || d.classList.contains('active') || d.classList.contains('animate');
    }

    function start() {
      if (!AUTOPLAY) return;
      if (!st || st.raf) return;
      // the drawer's contents are rebuilt on every cart change, which wakes the
      // childList observer below — without this the strip would spin behind a
      // closed panel for the rest of the session
      if (!drawerOpen()) return;
      st.last = 0;
      st.raf = requestAnimationFrame(frame);
    }

    /* ⚠ NOTHING HERE MOVES THE RAIL. It is rendered inside <cart-drawer-items>
       by cart-drawer.liquid, which is the only way it survives: an add-to-cart
       re-renders the drawer TWICE, and a JS relocation that lands between the
       two is carried off by the second. See the comment on the rail markup. */

    /* ── THE PRODUCT NAME, STATED BY THE SHEET ITSELF ──────────────────────
       ⚠ THE FETCHED TITLE CAN BE TAKEN AWAY FROM THE DIALOG. cvn-pdp-mobile-
       title's `home()` runs `document.querySelector('.product__title')` — a
       GLOBAL query, first match — and MOVES that element into the
       `.product__info-container` it latched onto at page load, re-firing from a
       MutationObserver the moment a `.product__title` appears. The dialog
       loading its product is exactly that event, so the dialog's own title gets
       adopted and re-homed somewhere outside it. It is gated on a phone media
       query, which is why the desktop panel never shows the problem and why
       forcing `visibility: visible` did nothing: the element is not hidden, it
       is gone. Nothing here is a bug in that file — it is a page-level feature
       reaching into a dialog through a global selector.
       So the name is taken from THE CARD THE SHOPPER CLICKED, which this file
       owns and nothing else touches, and written into the dialog's own sticky
       header. It lands the instant the sheet opens, with no race to lose. */
    function qvModal() { return document.querySelector('body > quick-add-modal.cvn-rail-modal'); }

    function qvSetName(name) {
      var m = qvModal();
      if (!m || !name) return false;
      var head = m.querySelector('.cvn-qv-head__t');
      if (!head) return false;
      if (head.textContent !== name) head.textContent = name;
      // the fail-safe switch the CSS keys on: set only once a name is really
      // on screen, so a failure leaves the sheet as it was rather than nameless
      m.classList.add('cvn-qv-named');
      return true;
    }

    function qvNameFromContent() {
      var m = qvModal();
      var src = m && m.querySelector('.product__title h1, .product__title h2, .product__title');
      return qvSetName(src ? (src.textContent || '').replace(/\s+/g, ' ').trim() : '');
    }

    /* Quantity and Add to cart on ONE line, quantity on the left (Zeus).
       The pieces start apart: the quantity block is rendered up in the scrolling
       info container while the submit sits in the sticky buy bar, so no amount
       of CSS can put them on a line together — the quantity has to move. There
       is already a `.cvn-buy-row` around the submit waiting for it: that is the
       PDP's own row, built by product-media-gallery's arrangeButtons(), which
       scopes itself to the PAGE's product info and so never reaches the dialog.
       This does for the sheet exactly what that does for the page. */
    function qvBuyRow() {
      var m = qvModal();
      var row = m && m.querySelector('.cvn-buy-row');
      var qty = m && m.querySelector('.product-form__quantity');
      var sub = m && m.querySelector('.product-form__submit');
      if (!row || !qty || !sub) return false;
      if (qty.parentNode !== row) row.insertBefore(qty, sub);
      return true;
    }

    function qvNameReset() {
      var m = qvModal();
      if (!m) return;
      var head = m.querySelector('.cvn-qv-head__t');
      // reset BEFORE the next product loads, or the previous product's name
      // sits in the header while a different garment loads underneath it
      if (head) head.textContent = 'Quick view';
      m.classList.remove('cvn-qv-named');
    }

    document.addEventListener('click', function (e) {
      if (!isPhone() || !e.target.closest) return;
      var btn = e.target.closest('.cvn-rail-qv');
      if (!btn) return;
      qvNameReset();
      var card = btn.closest('.card-wrapper');
      var nameEl = card && card.querySelector('.cvn-rail-name');
      var named = qvSetName(nameEl ? (nameEl.textContent || '').replace(/\s+/g, ' ').trim() : '');
      /* The dialog FETCHES its product, so the buy row arrives late and at no
         fixed moment — and so does the title, in the rare case the card carried
         no name. Poll briefly and stop the moment both are settled. */
      var tries = 0;
      (function poll() {
        var seated = qvBuyRow();
        if (!named) named = qvNameFromContent();
        if ((seated && named) || ++tries > 40) return;
        setTimeout(poll, 150);
      })();
    }, true);

    /* ⚠ THE POLL ABOVE IS THE FAST PATH, NOT THE GUARANTEE. It gives up after
       ~6s, and a fetch slower than that — measured once, right after a soft
       navigation while the new page was still settling — loses the seating for
       good: the dialog opens with Quantity stranded up in the scrolling content
       and nothing ever comes back for it. A deadline is the wrong shape for
       "whenever the content arrives". This watches instead, so the row is
       seated the moment the pieces exist however long that takes.
       Safe to leave running: qvBuyRow() is a no-op once the quantity is in the
       row, so the move it makes cannot re-trigger itself into a loop. */
    var qvSeatT = null;
    try {
      new MutationObserver(function () {
        if (qvSeatT) return;
        qvSeatT = setTimeout(function () {
          qvSeatT = null;
          if (isPhone()) qvBuyRow();
        }, 80);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}

    function bindOnce(scroll) {
      if (scroll.__cvnMqBound) return;
      scroll.__cvnMqBound = 1;
      var holdOn = function () { if (st && st.scroll === scroll) st.hold = true; };
      var holdOff = function () {
        if (!st || st.scroll !== scroll || !st.hold) return;
        st.hold = false;
        st.holdUntil = performance.now() + RESUME_MS;
      };
      // touch: press and hold pauses, release resumes. The release is on WINDOW
      // because a finger that slides off the strip never delivers it to the
      // element, and the strip would stay parked for the rest of the session.
      scroll.addEventListener('pointerdown', holdOn, { passive: true });
      window.addEventListener('pointerup', holdOff, { passive: true });
      window.addEventListener('pointercancel', holdOff, { passive: true });
      scroll.addEventListener('wheel', function () {
        if (st && st.scroll === scroll) st.holdUntil = performance.now() + RESUME_MS;
      }, { passive: true });
      // hover only where a hovering pointer actually exists
      scroll.addEventListener('mouseenter', function () { if (canHover()) holdOn(); });
      scroll.addEventListener('mouseleave', function () { if (canHover()) holdOff(); });

      /* DRAG TO SCROLL. Touch already scrolls this natively, so the gesture is
         added for every OTHER pointer kind — a mouse on a narrowed laptop
         window, where an overflow scroller with its scrollbar hidden otherwise
         has no way to be moved at all. ⚠ A pointerdown that starts on the chip
         row is left alone: that row runs its own drag, and grabbing both would
         scroll the strip while the shopper is picking a colour. */
      var drag = false, moved = false, sx = 0, sl = 0;
      scroll.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        if (e.target.closest && e.target.closest('.cvn-card-colors')) return;
        drag = true; moved = false; sx = e.clientX; sl = scroll.scrollLeft;
        scroll.classList.add('cvn-mq-drag');
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 4) moved = true;
        scroll.scrollLeft = sl - dx;
      });
      var endDrag = function () {
        if (!drag) return;
        drag = false;
        scroll.classList.remove('cvn-mq-drag');
        if (!moved) return;
        // a drag must not also open the thing it finished on; the capture
        // listener below eats that click, and the timer clears the flag when
        // the pointer came up somewhere that fires no click at all
        scroll.__cvnDragged = true;
        setTimeout(function () { scroll.__cvnDragged = false; }, 150);
      };
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
      scroll.addEventListener('click', function (e) {
        if (!scroll.__cvnDragged) return;
        scroll.__cvnDragged = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }

    /* Put the strip back the way the desktop panel expects it. Dropping the
       class alone is not enough: a browser window narrowed past 990 and then
       widened again would leave the desktop rail holding the loop clones and
       showing every card's name, neither of which belongs there. */
    function teardown() {
      stop();
      // ⚠ never the PAGE rail — see the note above prepPageRails(). Prefer the
      // rail we actually booted; fall back to the first NON-page one.
      var rail = (st && st.rail) || document.querySelector('[data-cvn-rail]:not([data-cvn-rail-context="page"])');
      if (rail && rail.getAttribute('data-cvn-rail-context') === 'page') { st = null; return; }
      var scroll = rail && rail.querySelector('[data-cvn-rail-scroll]');
      if (rail) rail.classList.remove('cvn-rail--mq');
      if (scroll) {
        scroll.querySelectorAll('[data-cvn-mq-clone]').forEach(function (c) { c.remove(); });
        scroll.__cvnMqCloned = 0;
        scroll.querySelectorAll('.cvn-rail-name').forEach(function (h) {
          h.classList.remove('cvn-rail-name');
          h.classList.add('visually-hidden');
          var info = h.closest('.card-wrapper');
          info = info && info.querySelector('.card__information');
          if (info) info.insertBefore(h, info.firstChild);
          h.__cvnMq = 0;
        });
        scroll.scrollLeft = 0;
      }
      st = null;
    }

    function boot() {
      // page furniture first, and unconditionally — it is not width-gated and
      // it must survive every teardown (see prepPageRails)
      prepPageRails();
      if (!isPhone()) { if (st) teardown(); return; }
      // the DRIVEN rail is the drawer's; on /cart the page's rail is also in
      // the document and comes second, so ask for the non-page one by name
      var rail = document.querySelector('[data-cvn-rail]:not([data-cvn-rail-context="page"])')
              || document.querySelector('[data-cvn-rail]');
      var scroll = rail && rail.querySelector('[data-cvn-rail-scroll]');
      if (!scroll) { if (st) teardown(); return; }
      if (st && st.scroll === scroll && rail.classList.contains('cvn-rail--mq')) { start(); return; }
      stop();
      prep(scroll);
      cloneHead(scroll);
      rail.classList.add('cvn-rail--mq');
      poke();
      bindOnce(scroll);
      st = { rail: rail, scroll: scroll, pos: scroll.scrollLeft || 0, setW: 0, raf: null, last: 0, hold: false, holdUntil: 0 };
      // measure after layout has run with the strip visible
      requestAnimationFrame(function () {
        measure();
        start();
      });
    }

    /* WHEN TO BOOT. The rail markup is re-rendered with the drawer on every
       cart mutation and arrives by innerHTML, so nothing in it can execute —
       every hook here is on `document` or on the <cart-drawer> root, both of
       which survive that swap and the theme's #MainContent swap. boot() is
       idempotent: a second call on the same strip only restarts the frame loop. */
    function schedule() { setTimeout(boot, 60); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
    else schedule();
    document.addEventListener('cvn:navigated', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if (mqPhone && mqPhone.addEventListener) mqPhone.addEventListener('change', function () { teardown(); schedule(); });
    window.addEventListener('resize', function () { if (st) measure(); });

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      // open → run; closed → stop the frame loop rather than spin it behind a
      // panel nobody can see
      new MutationObserver(function () {
        if (drawer.classList.contains('active') || drawer.classList.contains('animate')) {
          schedule();
        } else stop();
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      // the drawer's contents are replaced wholesale on every cart change; the
      // strip that comes back is a different node and needs preparing again
      var t = null;
      new MutationObserver(function () {
        if (t) clearTimeout(t);
        t = setTimeout(function () { t = null; boot(); }, 120);
      }).observe(drawer, { childList: true, subtree: true });
    }
  })();
